<script>
import DocumentEditor from "@/components/DocumentEditor";

export default {
  name: "DocumentForm",
  components: {
    DocumentEditor,
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
    textarea: {
      type: String,
      required: true,
    },
  },
  data: function () {
    return {
      data: { ...this.content },
    };
  },
  watch: {
    data: {
      handler: function (newVal) {
        document.querySelector(this.textarea).value = JSON.stringify(
          newVal,
          null,
          2,
        );
      },
      deep: true,
    },
  },
};
</script>

<template>
  <div>
    <DocumentEditor
      :content:json="data"
      @update:json="(json) => (data = json)"
    />
  </div>
</template>
